import { useEffect, useState } from "react";
import { FaArrowLeft } from "react-icons/fa";
import { apiPut } from "../../API/Api_Url";
import { toast } from "react-toastify";

function SupplierUpdateQuotationModal({ quotation, isOpen, onClose, setExpandedJob, GetAllPendingMaterialRequest }) {
    const [isLoading, setisLoading] = useState(false);
    const [QuotedItems, setQuotedItems] = useState([]);
    const [GST, setGST] = useState("");
    const [DeliveryTime, setDeliveryTime] = useState("");
    const [CreditTerms, setCreditTerms] = useState("");
    const [Note, setNote] = useState("");
    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (quotation) {
            setQuotedItems(quotation?.QuotedItems || []);
            setGST(quotation?.GST || "");
            setDeliveryTime(quotation?.DeliveryTime || "");
            setCreditTerms(quotation?.CreditTerms || "");
            setNote(quotation?.Note || "");
        }
    }, [quotation]);

    const handleItemChange = (idx, field, value) => {
        const updated = [...QuotedItems];
        updated[idx] = { ...updated[idx], [field]: value };
        if (field === "pricePerUnit") {
            updated[idx].totalPrice = updated[idx].quantity * Number(value || 0);
        }
        setQuotedItems(updated);
    };


    const handleSubmit = async () => {
        let newErrors = {};
        if (!QuotedItems.length) newErrors.QuotedItems = "At least one item required";
        if (!GST) newErrors.GST = "GST is required";
        if (!DeliveryTime) newErrors.DeliveryTime = "Delivery time is required";
        if (!CreditTerms) newErrors.CreditTerms = "Credit terms are required";
        if (!Note) newErrors.Note = "Note is required";

        setErrors(newErrors);
        if (Object.keys(newErrors).length > 0) return;

        try {
            setisLoading(true);

            const payload = {
                QuotedItems: QuotedItems.map(item => ({
                    materialName: item.materialName,
                    quantity: Number(item.quantity),
                    unit: item.unit,
                    pricePerUnit: Number(item.pricePerUnit),
                    totalPrice: Number(item.totalPrice),
                    brand: item.brand,
                    specifications: item.specifications,
                })),
                GST: Number(GST),
                DeliveryTime,
                CreditTerms,
                Note,
            };

            const response = await apiPut(
                `api/material-supplier/UpdateMaterialRequestBid/${quotation?._id}`,
                payload
            );

            if (response?.data) {
                toast.success(response?.message || "Quotation updated successfully!");
                onClose();
                setExpandedJob(null);
                GetAllPendingMaterialRequest();
            } else {
                toast.error(response?.message || "Failed to update quotation");
            }
        } catch (error) {
            console.error("Error updating quotation:", error);
            toast.error("Something went wrong. Please try again.");
        } finally {
            setisLoading(false);
        }
    };


    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
            <div className="bg-white rounded-xl shadow-lg p-5 max-w-4xl w-full max-h-[90vh] overflow-y-auto">
                <div className="flex items-center mb-4 border-b pb-2">
                    <FaArrowLeft
                        className="mr-2 cursor-pointer text-gray-600 hover:text-gray-800"
                        onClick={onClose}
                    />
                    <h2 className="text-lg font-bold text-gray-800">Update Quotation</h2>
                </div>

                <div className="space-y-3">
                    {QuotedItems?.map((item, idx) => (
                        <div
                            key={item?._id || idx}
                            className="border rounded-lg p-4 bg-gray-50"
                        >
                            <h3 className="font-semibold text-gray-700 mb-2">
                                {item?.materialName}
                            </h3>
                            <div className="grid grid-cols-2 md:grid-cols-3 gap-3 text-sm">
                                <div>
                                    <label className="block text-xs text-gray-600">Qty</label>
                                    <input
                                        type="number"
                                        value={item?.quantity}
                                        disabled
                                        className="w-full border rounded px-2 py-1 bg-gray-100"
                                    />
                                </div>
                                <div>
                                    <label className="block text-xs text-gray-600">Unit</label>
                                    <input
                                        type="text"
                                        value={item?.unit}
                                        disabled
                                        className="w-full border rounded px-2 py-1 bg-gray-100"
                                    />
                                </div>
                                <div>
                                    <label className="block text-xs text-gray-600">Price/Unit</label>
                                    <input
                                        type="number"
                                        value={item?.pricePerUnit}
                                        onChange={(e) =>
                                            handleItemChange(idx, "pricePerUnit", e.target.value)
                                        }
                                        className="w-full border rounded px-2 py-1"
                                    />
                                </div>
                                <div>
                                    <label className="block text-xs text-gray-600">Total</label>
                                    <input
                                        type="number"
                                        value={item?.totalPrice}
                                        disabled
                                        className="w-full border rounded px-2 py-1 bg-gray-100"
                                    />
                                </div>
                                <div>
                                    <label className="block text-xs text-gray-600">Brand</label>
                                    <input
                                        type="text"
                                        value={item?.brand}
                                        onChange={(e) =>
                                            handleItemChange(idx, "brand", e.target.value)
                                        }
                                        className="w-full border rounded px-2 py-1"
                                    />
                                </div>
                                <div className="col-span-2 md:col-span-3">
                                    <label className="block text-xs text-gray-600">
                                        Specifications
                                    </label>
                                    <input
                                        type="text"
                                        value={item?.specifications}
                                        onChange={(e) =>
                                            handleItemChange(idx, "specifications", e.target.value)
                                        }
                                        className="w-full border rounded px-2 py-1"
                                    />
                                </div>
                            </div>
                        </div>
                    ))}
                    {errors?.QuotedItems && (
                        <p className="text-xs text-red-500">{errors.QuotedItems}</p>
                    )}
                </div>

                <div className="mt-5 space-y-3 bg-gray-50 p-4 rounded-lg">
                    <h4 className="text-sm font-semibold text-gray-800">Quotation Details</h4>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                        <div>
                            <label className="block text-xs font-medium text-gray-600 mb-1">
                                GST (%)
                            </label>
                            <input
                                type="number"
                                value={GST}
                                onChange={(e) => setGST(e.target.value)}
                                placeholder="GST (%)"
                                className="border rounded px-2 py-1 w-full"
                            />
                            {errors?.GST && (
                                <p className="text-xs text-red-500">{errors.GST}</p>
                            )}
                        </div>
                        <div>
                            <label className="block text-xs font-medium text-gray-600 mb-1">
                                Delivery Time
                            </label>
                            <input
                                type="text"
                                value={DeliveryTime}
                                onChange={(e) => setDeliveryTime(e.target.value)}
                                placeholder="Delivery Time"
                                className="border rounded px-2 py-1 w-full"
                            />
                            {errors?.DeliveryTime && (
                                <p className="text-xs text-red-500">{errors.DeliveryTime}</p>
                            )}
                        </div>
                        <div>
                            <label className="block text-xs font-medium text-gray-600 mb-1">
                                Credit Terms
                            </label>
                            <input
                                type="text"
                                value={CreditTerms}
                                onChange={(e) => setCreditTerms(e.target.value)}
                                placeholder="Credit Terms"
                                className="border rounded px-2 py-1 w-full"
                            />
                            {errors?.CreditTerms && (
                                <p className="text-xs text-red-500">{errors.CreditTerms}</p>
                            )}
                        </div>
                        <div className="md:col-span-2">
                            <label className="block text-xs font-medium text-gray-600 mb-1">
                                Note
                            </label>
                            <textarea
                                value={Note}
                                onChange={(e) => setNote(e.target.value)}
                                rows={2}
                                placeholder="Note"
                                className="border rounded px-2 py-1 w-full"
                            />
                            {errors?.Note && (
                                <p className="text-xs text-red-500">{errors.Note}</p>
                            )}
                        </div>
                    </div>
                </div>


                <div className="mt-5 flex justify-end gap-3">
                    <button
                        onClick={onClose}
                        className="px-4 py-1.5 border rounded hover:bg-gray-100 text-sm"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={handleSubmit}
                        disabled={isLoading}
                        className="px-4 py-1.5 bg-blue-600 text-white rounded hover:bg-blue-700 text-sm disabled:opacity-50"
                    >
                        {isLoading ? "Updating..." : "Update Quotation"}
                    </button>
                </div>
            </div>
        </div>
    );
}

export default SupplierUpdateQuotationModal